import React from 'react'
import '../components-css/certificate-page.scss'
import certificate1Img from '../pngs/certificate.jpg'
import certificate2Img from '../pngs/certificate2.jpg'
import { Helmet } from 'react-helmet-async';

const CertificatePage = () => {
  return (
    <div className="certificate-page-container">
      <Helmet>
        <title>Omka Tech Certifications | Industry Credentials</title>
        <meta name="description" content="Explore Omka Tech's certifications in web development, mobile app development, IT services, and digital marketing" />
        <link rel="canonical" href="https://omkatech.com/certifications" />
        <link rel="preload" as="image" href={certificate1Img} fetchpriority="high" />
        <link rel="preload" as="image" href={certificate2Img} fetchpriority="high" />
      </Helmet>

      <h1>Our Certifications & Industry Awards</h1>

      <div className="certificate-images">
        <img
          src={certificate1Img}
          alt="Omka Tech Certificate 1"
          loading="eager"
          decoding="sync"
          fetchpriority="high"
          width={600}    // ✅ Matches real rendered width
          height={849}   // ✅ Matches real rendered height (599 × 847 aspect ratio)
          style={{ width: '100%', maxWidth: '599px', height: 'auto' }}
        />
        <img
          src={certificate2Img}
          alt="Omka Tech Certificate 2"
          loading="eager"
          decoding="sync"
          fetchpriority="high"
          width={600}    // ✅ Use same width for consistency
          height={849}   // ✅ Adjust if certificate2 has a different ratio
          style={{ width: '100%', maxWidth: '599px', height: 'auto' }}
        />
      </div>
    </div>
  )
}

export default CertificatePage